<template>
    <div class="contacts-section" v-if="data" :id="itemId">
        <div class="gray-superlight-bg u-all-padding--s u-bottom-margin--m">
            <h5 class="u-top-margin--no black-40-text" v-html="data.detail.name"></h5>
            <div v-if="data.detail.properties && data.detail.properties.length">
                <template v-for="(itemA, indexA) in data.detail.properties">
                    <span
                        class="u-right-margin--s"
                        :key="indexA"
                        v-if="isPropsShown(itemA)"
                    >
                        <span class="black-40-text">{{ itemA.name }}: </span>
                        <template v-for="(itemB, indexB) in itemA.items">
                            <z-link
                                v-if="isLinkType(itemB.type)"
                                class="contacts-section__value"
                                :key="indexB"
                                :href="buildLink(itemB)"
                            >
                                <span v-html="itemB.value"></span>
                            </z-link>
                            <span
                                v-else
                                :key="indexB"
                                v-html="itemB.value"
                                class="contacts-section__value"
                            >
                            </span>
                            <template v-if="(itemB + 1) < itemA.items.length">, </template>
                        </template>
                    </span>
                </template>
            </div>
        </div>

        <div

            v-if="data.detail.people && data.detail.people.length"
        >
            <div class="row">
                <div
                    class="col-default-4 col-tablet-6 col-v-tablet-12 contacts__col"
                    v-for="(itemA, indexA) in filteredDirector"
                    :key="`${indexA}-dir`"
                >
                    <contacts-card :hidden-contacts="hiddenContacts" :data="itemA" />
                </div>
                <div
                    class="col-default-8 col-tablet-6 col-v-tablet-12"
                    v-if="data.detail.directorate"
                >
                    <z-list>
                        <template v-for="(itemA, indexA) in data.list">
                            <z-list-item
                                :key="indexA"
                                v-if="!itemA.directorate"
                            >
                                <z-link :href="`#${itemA.code}`" theme="black">
                                    <span v-html="itemA.name"></span>
                                </z-link>
                            </z-list-item>
                        </template>
                    </z-list>
                </div>
            </div>
            <div class="row">
                <div
                    class="col-default-4 col-tablet-6 col-v-tablet-12 contacts__col"
                    v-for="(itemA, indexA) in filteredWithoutDirector"
                    :key="`${indexA}-people`"
                >
                    <contacts-card :hidden-contacts="hiddenContacts" :data="itemA" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'contacts-section',
    props: {
        data: [Object, Array],
        hiddenContacts: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            itemId: this.data.detail.code
        }
    },
    computed: {
        filteredDirector () {
            return this.data.detail.people.filter(item => item.director)
        },
        filteredWithoutDirector () {
            return this.data.detail.people.filter(item => !item.director)
        }
    },
    methods: {
        isPropsShown (item) {
            let result = item.items.filter(prop => prop.value)

            return !!result.length
        },
        getName (item) {
            return item.value.split('_')[0]
        },
        getValue (item) {
            return item.value.split('_')[1]
        },
        isLinkType (type) {
            const typeArr = ['phone', 'fax', 'email']

            return typeArr.includes(type)
        },
        buildLink (item) {
            let startLinkArr = {
                phone: 'tel:',
                email: 'mailto:',
                fax: 'fax:'
            }

            return `${startLinkArr[item.type]}${item.value}`
        }
    }
}
</script>
